module.exports = __webpack_public_path__ + "img/yandex-international.abd1d6fc.svg";